import { render, staticRenderFns } from "./creative-form-components.vue?vue&type=template&id=124ede90&scoped=true"
import script from "./creative-form-components.vue?vue&type=script&setup=true&lang=js"
export * from "./creative-form-components.vue?vue&type=script&setup=true&lang=js"
import style0 from "./creative-form-components.vue?vue&type=style&index=0&id=124ede90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "124ede90",
  null
  
)

export default component.exports